<template>
<div class="bg" :style="style">
        <header>
            <div class="navbar fixed-top">
                <router-link class="navbar-brand" to="/">
					<img src="img/logo.svg" alt="Insurance4Models" />
				</router-link>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <transition name="component-fade" mode="out-in">           
                            <div class="content min-vh-100 flex-column d-flex justify-content-center text-center">
                                <div>
                                    <span class="font-italic font-weight-bold font-italic font-xxl text-primary mb-2 d-block">404</span>
                                    <span class="font-l">Page not found</span> 
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </main>
        <Footer/>
    </div>
</template>

<script>
import Footer from '../components/Footer'

export default {
    components: {
        Footer,
    }, 
}
</script>